export const OPERATOR_TASK_CALENDAR_LIMIT = 10000;
export const OPERATOR_TASK_CALENDAR_DEFAULT_PAGE_SIZE = 1000;
